export default __webpack_public_path__ + "static/media/pin-arrival.24023b73.png";